import React, {Component} from 'react'
import fontlist from './helpers/fontlist'
import ReactSelect from 'react-select'
import _ from 'lodash'
import LinkWithTooltip from '../../tooltip';

class Fonts extends Component {

  constructor(props) {
    super(props);

    this.state ={
      options: [],
      value: '',
      multi: this.props.params.multiple
    }
  }

  logChange(val){
    const { input: { value, onChange, name } } = this.props

    this.setState({
      value: val
    })

    if (val == null) {
      onChange('')
    } else if (typeof val.length != 'undefined') {
      var arrayVal = [];
      for (var i = 0; i < val.length; i++) {
        arrayVal[i] = val[i].value;
      }
      onChange( arrayVal );
    } else {
      onChange( val.value );
    }
  }

  render(){
    const { input, params } = this.props

    return(
      <div className="sp-pagebuilder-form-group" >
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <ReactSelect
          name={ input.name }
          value={ this.props.input.value }
          multi={ this.state.multi }
          options={ fontlist }
          onChange={ this.logChange.bind(this) }
        />
      </div>
    )
  }
}

export default Fonts;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Fonts.js